import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import KitSelectStyle from './AiKitSelection.module.css'
import renderImage from '../../source/importImg'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { setLanguageSelect } from '../../redux/actions'
import { connect } from 'react-redux'
import { languageMenu } from '../../utils/langaugeSupport'
import { tabs } from '../../utils/kitTabs'
import KitSelectionHeader from '../ReusableComponents/Header/KitSelectionHeader'

const AiKitSelection = (props) => {
    const [supportedDevice, setSupportedDevice] = useState([])
    const [filteredResults, setFilteredResults] = useState({})
    const [aiDeviceObj, setAiDeviceObj] = useState({})
    const [showLanguagePopup, setShowLanguagePopup] = useState(false)
    const [languageValue, setLanguageValue] = useState(props.device.language)

    const [modelData, setModelData] = useState({
        isShow: false,
        text: '',
        type: '',
    })

    const history = useHistory()

    const aiDevice =
        props.device.kitSelection.selectedKit?.aiKitSelected ?? 'pcAiTool'

    useEffect(() => {
        if (!aiDevice) {
            setSupportedDevice([])
            setAiDeviceObj({})
            return
        }

        const allDevices = tabs.flatMap((tab) =>
            tab.content.map((device) => ({
                ...device,
                tabId: tab.id,
                tabTitle: tab.title,
            }))
        )

        setAiDeviceObj(allDevices.find((d) => d.device === aiDevice) || {})

        const supported = allDevices.filter((d) =>
            d.aiSupport?.includes(aiDevice)
        )

        // special ordering ONLY for Ai0
        if (aiDevice === 'Ai0') {
            const priority = (d) => {
                if (d.device === 'Poki' && d.tabTitle === 'Codable Modules')
                    return 1
                if (d.device === 'Poki' && d.tabTitle === 'Codable Kits')
                    return 2
                if (d.device === 'Moki' && d.tabTitle === 'Codable Modules')
                    return 3
                if (d.device === 'Moki' && d.tabTitle === 'Codable Kits')
                    return 4
                return 99
            }

            supported.sort((a, b) => priority(a) - priority(b))
        }

        setSupportedDevice(supported)
    }, [aiDevice])

    const handleAutoConnection = () => {
        history.push('/deviceSelection')
    }
    // const handleDefaultConnection = () => {}
    const handleDeviceConnection = (item) => {
        if (['Playtrons', 'Playtronix', 'Playdynamex'].includes(item.name))
            window.open(item.nav, '_blank')
        else {
            props.setSelectedKit({
                ...item,
                aiKitSelected:
                    props.device.kitSelection.selectedKit?.aiKitSelected,
            })
            sessionStorage.setItem('allowedDevice', item.device)
            history.push('/deviceSelection')
        }
    }

    const languageActionHandel = () => {
        props.setLanguageSelect({ language: languageValue })
        setShowLanguagePopup(false)
    }

    const gobackUrl = () => {
        sessionStorage.setItem('slideDirection', true)
        history.push('/kitSelection')
    }

    return (
        <>
            <DialogModal
                show={showLanguagePopup}
                text={
                    <div>
                        <p>Select Your Prefer language</p>
                        <div>
                            <select
                                className={KitSelectStyle.language_select}
                                value={languageValue}
                                onChange={(e) =>
                                    setLanguageValue(e.target.value)
                                }
                            >
                                {languageMenu.map((ele) => {
                                    return <option value={ele}>{ele}</option>
                                })}
                            </select>
                        </div>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setShowLanguagePopup(false)}
                optionsToSelect={[
                    {
                        text: 'CONTINUE',
                        do: () => {
                            languageActionHandel()
                        },
                    },
                ]}
            />
            <KitSelectionHeader
                setShowLanguagePopup={setShowLanguagePopup}
                setFilteredResults={setFilteredResults}
                filteredResults={filteredResults}
                supportedDevice={supportedDevice}
            />

            <div className={KitSelectStyle.container}>
                <div className={KitSelectStyle.Connect_Body}>
                    <div
                        className={KitSelectStyle.sidebar}
                        style={{ padding: '1.25rem 0' }}
                    >
                        <div className={KitSelectStyle.sidebarCardParent}>
                            <div className={KitSelectStyle.sidebarCard}>
                                <div className={KitSelectStyle.cardImg}>
                                    <img
                                        src={renderImage(aiDeviceObj.src)}
                                        alt={aiDeviceObj.src}
                                    />
                                </div>
                                <p className={KitSelectStyle.cardName}>
                                    {aiDeviceObj.name}
                                </p>
                            </div>
                        </div>
                        <button
                            className={KitSelectStyle.sidebarButton}
                            // disabled={true}
                        >
                            SOLO USE
                        </button>
                    </div>
                    <div className={KitSelectStyle.content}>
                        <p className={KitSelectStyle.contentPara}>
                            Select device to work with it
                        </p>
                        <div>
                            {filteredResults &&
                            Object.keys(filteredResults).length > 0 ? (
                                <div className={KitSelectStyle.tabContent}>
                                    <div
                                        onClick={() =>
                                            handleDeviceConnection(
                                                filteredResults
                                            )
                                        }
                                        className={KitSelectStyle.card}
                                    >
                                        <div className={KitSelectStyle.cardImg}>
                                            <img
                                                src={renderImage(
                                                    filteredResults.src
                                                )}
                                                alt={filteredResults.src}
                                            />
                                        </div>
                                        <p className={KitSelectStyle.cardName}>
                                            {filteredResults.name}
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div className={KitSelectStyle.tabContent}>
                                    {supportedDevice.map((ele, ind) => (
                                        <div
                                            key={ind}
                                            onClick={() =>
                                                handleDeviceConnection(ele)
                                            }
                                            className={KitSelectStyle.card}
                                        >
                                            <div
                                                className={
                                                    KitSelectStyle.cardImg
                                                }
                                            >
                                                <img
                                                    src={renderImage(ele.src)}
                                                    alt={ele.src}
                                                />
                                            </div>
                                            <p
                                                className={
                                                    KitSelectStyle.cardName
                                                }
                                            >
                                                {ele.name}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className={KitSelectStyle.Connect_Footer}>
                    <div>
                        <img
                            style={{ width: '90px', cursor: 'pointer' }}
                            src={renderImage('auto')}
                            alt="arrowRight"
                            onClick={handleAutoConnection}
                        />
                    </div>
                </div>

                <img
                    onClick={() => gobackUrl()}
                    // className="nextButton" //search for ".nextButton" in project directory to edit style
                    id="uploadLogicscrn"
                    src={renderImage('backBtn')}
                    style={{
                        position: 'absolute',
                        visibility: 'visible',
                        // top: '91%',
                        bottom: '4%',
                        left: '2%',
                        width: '60px',
                        // height: '60px',
                        cursor: 'pointer',
                        opacity: '1',
                    }}
                ></img>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        setLanguageSelect: (data) => {
            dispatch(setLanguageSelect(data))
        },
        setSocket: (data) => {
            dispatch({ type: 'SOCKET', payload: data })
        },
        setSelectedKit: (data) => {
            dispatch({ type: 'SET_SELECTED_KIT', payload: data })
        },
        setActiveTab: (data) => {
            dispatch({ type: 'SET_ACTIVE_TAB', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AiKitSelection)
